import { render, staticRenderFns } from "./RecentBirthdate.vue?vue&type=template&id=4ffbfcf0&"
import script from "./RecentBirthdate.vue?vue&type=script&lang=js&"
export * from "./RecentBirthdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports